import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { url: String }
  static targets = [
    'patientSelect',
    'pin', 'firstName', 'middleName', 'lastName',
    'birthDate', 'gender', 'mobile', 'clientType',
    'memberPin', 'memberName', 'memberBirthDate', 'memberGender',
    'walkedIn', 'atcCode'
  ]

  connect() {
    if (this.hasPatientSelectTarget && this.patientSelectTarget.value) {
      this.fetchAndFill(this.patientSelectTarget.value)
    }
    this._onPatientRefresh = (e) => this.fetchAndFill(e.detail.id)
    document.addEventListener('patient:refresh', this._onPatientRefresh)
  }

  disconnect() {
    document.removeEventListener('patient:refresh', this._onPatientRefresh)
  }

  async populate(event) {
    const id = event.target.value
    if (!id) {
      this.clearFields()
      return
    }
    this.fetchAndFill(id)
  }

  async fetchAndFill(id) {
    const url = this.urlValue.replace(':id', id) + '.json'
    try {
      const response = await fetch(url, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
      if (!response.ok) return
      const patient = await response.json()
      this.fillPatient(patient)
    } catch (_) {
      // silently ignore network errors
    }
  }

  fillPatient(patient) {
    this.setTarget('pin', patient.phic_id_number)
    this.setTarget('firstName', patient.first_name)
    this.setTarget('middleName', patient.middle_name)
    this.setTarget('lastName', patient.last_name)
    this.setTarget('birthDate', patient.birth_date)
    this.setTarget('gender', patient.gender)
    this.setTarget('mobile', patient.mobile_number)
    this.setTarget('clientType', patient.patient_type)

    const member = patient.member
    if (member) {
      this.setTarget('memberPin', member.phic_id_number)
      this.setTarget('memberName', member.full_name)
      this.setTarget('memberBirthDate', member.birth_date)
      this.setTarget('memberGender', member.gender)
    }
  }

  syncAtcCode() {
    if (!this.hasAtcCodeTarget) return
    this.atcCodeTarget.value = this.hasWalkedInTarget && this.walkedInTarget.checked ? 'WALKEDIN' : ''
  }

  clearFields() {
    const allTargets = [
      'pin', 'firstName', 'middleName', 'lastName',
      'birthDate', 'gender', 'mobile', 'clientType',
      'memberPin', 'memberName', 'memberBirthDate', 'memberGender'
    ]
    allTargets.forEach(name => this.setTarget(name, ''))
  }

  setTarget(name, value) {
    const key = `has${name.charAt(0).toUpperCase()}${name.slice(1)}Target`
    if (this[key]) this[`${name}Target`].value = value ?? ''
  }
}
